import { render, staticRenderFns } from "./light-guest-list.vue?vue&type=template&id=538690a1&"
import script from "./light-guest-list.vue?vue&type=script&lang=ts&"
export * from "./light-guest-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports